module.exports = __webpack_public_path__ + "static/img/13.16ddda5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/13.png
// module id = h7nP
// module chunks = 0